import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["canvas", "input"];

  connect() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    this.canvasTarget.width = this.canvasTarget.offsetWidth * ratio;
    this.canvasTarget.height = this.canvasTarget.offsetHeight * ratio;
    this.canvasTarget.getContext("2d").scale(ratio, ratio);

    this.signaturePad = new window.SignaturePad(this.canvasTarget);
    this.signaturePad.addEventListener("afterUpdateStroke", () => this.#setSignature(this.signaturePad.toDataURL()));
  }

  disconnect() {
    this.signaturePad.off();
  }

  clear() {
    this.signaturePad.clear();
    this.#setSignature("");
  }

  #setSignature(value) {
    this.inputTarget.value = value;
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
